import React from 'react'
import {Grid, Typography, Card, CardMedia, CardContent, CardActions, Button} from '@material-ui/core'
import useStyles from '../Styles'
import logoPundi from '../img/pundi.png'

export default function Portfolio(){
    const useStyle = useStyles();
    return(
        <Grid container justifyContent='center' alignContent='center' className={useStyle.portContainer}>
            <Grid item md={4} sm={6} xs={12}>
                <Card style={useStyle.itemPort}>
                    <CardMedia component='img' image={logoPundi}/>
                    <CardContent>
                        <Typography variant='h4'>
                            Pundi Receh
                        </Typography>
                        <Typography variant='subtitle1'>
                            PundiReceh is a stock website managed by, and for those whose hobby is in the financial and investment sectors.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button variant='contained' href='https://pundi-receh.web.app/' color='primary'>Go to Web</Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    )
}